<template>
  <router-view></router-view>
</template>

<script>
import {
  callPage,
  updateOrganization,
  generateAppToken,
  appcuesCallbacks
} from "./utils/appcues";
import { logout, isLoggedIn } from "./utils/auth0";
export default {
  mounted() {
    let cbStyle = document.createElement("link");
    cbStyle.setAttribute(
      "href",
      "https://d2jxbtsa1l6d79.cloudfront.net/static/app-static-assets/hp/hp-perf-optimize-v6/stylesheets/hp_app.css"
    );
    cbStyle.setAttribute("rel", "stylesheet");
    cbStyle.setAttribute("type", "text/css");
    document.head.appendChild(cbStyle);

    let me = this;
    //if we haven't sent the current user to appcues do it now
    if (
      localStorage.getItem("userId") !== null &&
      localStorage.getItem("apc_user_id") === null
    ) {
      if (localStorage.getItem("organizationId") !== null) {
        me.$store
          .dispatch(
            "organization/loadOrganization",
            localStorage.organizationId
          )
          .then(result => {
            updateOrganization(result);
          });
      }
    } else {
      callPage();
    }
    // generate and expose a token to Appcues
    generateAppToken();
    // allow app to know when a tour has started
    appcuesCallbacks();

    //if we have an organization we should load it and store it
    if (localStorage.organizationId) {
      this.$store.dispatch(
        "organization/loadOrganization",
        localStorage.organizationId
      );
    }

    // session timer
    function checkLoginTime() {
      currTime = new Date().getTime();
      if (!localStorage.getItem("loginTime")) {
        localStorage.setItem("loginTime", currTime);
      } else if (
        currTime - localStorage.getItem("loginTime") >
        86400000 // 24 * 60 * 60 * 1000
      ) {
        clearInterval(sessionTimeout);
        logout();
      }
    }
    if (isLoggedIn()) {
      var currTime;
      checkLoginTime();
      var sessionTimeout = setInterval(checkLoginTime, 10000);
    }
  }
};
</script>
